// extracted by mini-css-extract-plugin
export var bottomRightDock = "_1d-0";